import { render, staticRenderFns } from "./Digital.vue?vue&type=template&id=55d4d8a0&"
import script from "./Digital.vue?vue&type=script&lang=js&"
export * from "./Digital.vue?vue&type=script&lang=js&"
import style0 from "./Digital.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports